import "./style.less"
import {Link} from "react-router-dom";
import * as RouteWays from "../../enums/routes";
import PhoneButton from "../main-buttons/phone-button/PhoneButton";

const SiteHeader = () => {
  return <div className="site-header-content">
    <Link className="site-brand" to={RouteWays.HOME} aria-label="На головну сторінку">
      <span className="site-brand__logo-wrap">
        <img className="site-brand__logo" src="/main_logo.jpg" alt="Логотип Близнюківської центральної районної лікарні"/>
      </span>

      <span className="site-brand__text">
        <span className="site-brand__meta">
          <span className="site-brand__status-dot" aria-hidden="true"/>
          Офіційний сайт
        </span>
        <span className="site-brand__name">
          Близнюківська центральна районна лікарня
        </span>
        <span className="site-brand__legal-name">Комунальне підприємство</span>
      </span>
    </Link>

    <div className="site-header-content__actions">
      <PhoneButton/>
    </div>
  </div>
}

export default SiteHeader
